import ApiService from "@/core/services/api.service";

//Actions
export const FETCH_USERS_BASIC = "fetchUsersBasic";
export const FETCH_CURRENT_USER = "fetchCurrentUser";

//Mutations
export const SET_LOADING = "setLoadingSharedUser";

const state = {
  isLoadingSharedUser: false
};

const getters = {
  isLoadingSharedUser() {
    return state.isLoadingSharedUser;
  }
};

const actions = {
  [FETCH_USERS_BASIC](context, apiParams = "") {
    context.commit(SET_LOADING, true);
    return new Promise((resolve, reject) => {
      ApiService.get("users-basic" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FETCH_CURRENT_USER](context) {
    context.commit(SET_LOADING, true);
    return new Promise((resolve, reject) => {
      ApiService.get("current-user")
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  }
};

const mutations = {
  [SET_LOADING](state, value) {
    state.isLoadingSharedUser = value;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
